import * as React from "react";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { IMapOptions } from "../interfaces/mapoptions";
import HalfwayData from "./halfwaydata";

const StartEnd = () => {
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);

    const poiDescription = mapoptions.halfway?.routeDescription;

    let halfwayDescription: JSX.Element = null;

    if (poiDescription) {
        halfwayDescription = (<li className="infolabel description">
            <span className="d-none d-sm-inline" dangerouslySetInnerHTML={{ __html: poiDescription }}></span>
        </li>)
    }

    return (
        <div className="initial-data">


            <div className="loc-info">
                <ul>
                    <li className="infolabel halfway-point">
                        <HalfwayData />
                    </li>
                    <li className="infolabel first-location">
                        <i className="main-location-marker a-marker">A</i>
                        <span className="d-none d-sm-inline">First Location:</span> <span title={mapoptions.address1}>{mapoptions.address1}</span>
                    </li>
                    <li className="infolabel second-location">
                        <i className="main-location-marker b-marker">B</i>
                        <span className="d-none d-sm-inline">Second Location:</span> <span title={mapoptions.address2}>{mapoptions.address2}</span>
                    </li>
                    {halfwayDescription}
                </ul>
            </div>


        </div>);
};


export default StartEnd;

